module.exports = __webpack_public_path__ + "static/media/sidebar-agent-management.a114a11b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/sidebar-agent-management.svg
// module id = 809
// module chunks = 0